export default __webpack_public_path__ + "static/screeny-130-ga-3-62d220ebfb8d8f82c0a4fa559b972b46.jpg";